/* Parallax, and reveals that re-arm.
 *
 * Deliberately small and dependency free. Everything it does is decoration, so
 * it bails out completely under prefers-reduced-motion and the page is left as
 * the perfectly good static thing it already was.
 *
 * Two jobs:
 *   1. Drift the background patterns against the scroll, so sections have depth
 *      rather than being flat panes of colour sliding past.
 *   2. Re-arm the scroll reveals. cart.js reveals an element once and then stops
 *      watching it; on a long sales page that means everything above the fold on
 *      the way back up is already spent. This lets them play again.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  /* ---------- Parallax ---------- */
  var items = [];

  function collect() {
    items = [];
    document.querySelectorAll('.tex').forEach(function (el) {
      el.classList.add('is-parallax');
      items.push({ el: el, k: 0.09 });
    });
    document.querySelectorAll('[data-parallax]').forEach(function (el) {
      items.push({ el: el, k: parseFloat(el.getAttribute('data-parallax')) || 0.06 });
    });
  }

  var ticking = false;

  function update() {
    ticking = false;
    var vh = window.innerHeight;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var r = it.el.getBoundingClientRect();
      /* Off screen by more than a screen height: not worth a style write. */
      if (r.bottom < -vh || r.top > vh * 2) continue;
      /* Distance of the element's centre from the viewport's, so the drift is
         zero when the section is centred and symmetrical either side of it. */
      var offset = (r.top + r.height / 2) - vh / 2;
      it.el.style.transform = 'translate3d(0,' + (-offset * it.k).toFixed(2) + 'px,0)';
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  /* ---------- Reveals that re-arm ----------
     Generous margins on purpose. An element is only un-revealed once it is a
     good way outside the viewport, so nothing is ever seen fading while it is
     still being read. */
  function bindRepeat() {
    var els = document.querySelectorAll('.reveal, .reveal-up, .reveal-scale');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-visible', entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    collect();
    if (items.length) {
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }
    bindRepeat();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
